


































import { Component, Prop, Vue } from 'vue-property-decorator'
import { ItunesTrack } from '@/classes/itunes'

@Component({
  components: {
    GlobalWaveform: require('@/components/GlobalWaveform').default
  }
})
export default class MusicChartsTrack extends Vue {
  @Prop()
  rank: number

  @Prop()
  isOwned: boolean

  @Prop()
  isNew: boolean

  @Prop()
  track: ItunesTrack

  loading: boolean = false

  get viewUrlWithToken(): string {
    const url = new URL(this.track.viewUrl)

    url.searchParams.append('at', '1001l32Qi')

    return url.toString()
  }

  get name(): string {
    return `<strong class="mr-s">#${this.rank}</strong> ${this.track.title} - ${this.track.artistName}`
  }

  async markOwned() {
    this.loading = true

    await this.$store.dispatch('musiccharts/markItunesTrackOwned', this.track.itunesTrackId)

    this.loading = false
  }

  async markNotOwned() {
    this.loading = true

    await this.$store.dispatch('musiccharts/markItunesTrackNotOwned', this.track.itunesTrackId)

    this.loading = false
  }
}
